import { masterBreakPoint, maxWidth600 } from "themes/default/breakpoints"
import { theme } from "themes/default/theme"

export const styles = {
  paper: {},
  content: {
    bgcolor: "#f7f6f2",
    // mt: 1.25,
    borderRadius: 2.5,
    p: 1.875,
    position: "relative",
  },
  header: {
    backgroundColor: "#f88b1a",
    px: 1.25,
    py: 0.625,
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 2.5,
    [maxWidth600]: {
      // p: 2,
      // borderRadius: 0,
    },
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    flex: 1,
  },
  backButton: {
    position: "absolute",
    top: 5,
    left: 5,
    zIndex: 100,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  selectTeamText: {
    color: "white",
    flex: 1,
  },
  headerRight: {
    bgcolor: "rgba(239, 239, 239, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    py: 1.25,
    px: 1.875,
    borderRadius: 1.25,
  },
  currentUserNameText: {
    color: "#545454",
    whiteSpace: "nowrap",
    textAlign: "center",
  },
  studentsListContainer: {
    position: "relative",
    overflowY: "auto",
    p: 1.875,
  },
  studentList: {
    position: "relative",
    flex: 1,
    width: "100%",
    // display: "grid",
    // gridTemplateColumns: "repeat(5, minmax(140px, 1fr))",
    // gap: 2.5,
    // maxWidth: "100%",
    // [maxWidth600]: {
    //     gridTemplateColumns: "repeat(2, 1fr)",
    //     gap: 2,
    // }
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    mt: 0.625,
  },
  acceptButton: {
    color: "white",
    px: 5,
    py: 1.25,
    borderRadius: "8px",
    textTransform: "none",
    lineHeight: "1",
  },
  teamItem: {
    position: "relative",
    bgcolor: "white",
    borderRadius: 2.5,
    px: 1.25,
    py: 2.5,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-start",
    transition: "all 0.2s ease",
    backgroundColor: theme.palette.common.white,
    width: 196,
    minHeight: 200,
    cursor: "pointer",
    userSelect: "none",
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
    [maxWidth600]: {
      width: "100%",
      minHeight: "initial",
    },
  },
  teamAvatar: {
    width: 100,
    height: 100,
    mb: 1.5,
    [maxWidth600]: {
      width: 50,
      height: 50,
    },
  },
  teamNameText: {
    maxWidth: 150,
    textAlign: "center",
    [masterBreakPoint]: {
      fontSize: 16,
    },
  },
  teamUsernameText: {
    maxWidth: 150,
    textAlign: "center",
    color: "rgba(0, 0, 0, 0.5)",
  },
  currentUserItem: {
    cursor: "default",
    border: `2px dashed ${theme.palette.primary.main}`,
    boxShadow: "#ff6a00 0px 1px 4px",
  },
  selectedTeamItem: {
    border: `2px dashed rgb(43, 181, 33)`,
    backgroundColor: "rgb(237, 255, 236)",
    boxShadow: "rgb(43, 181, 33) 0px 1px 4px",
  },
  teamItemLoading: {
    boxShadow: "rgba(0, 0, 0, 0.5) 0px 1px 4px",
    border: `2px dashed rgba(0, 0, 0, 0.5)`,
  },
}
